import type { ComponentType, PropsWithChildren } from 'react';
import { lazy } from 'react';

const LoadableResizableLeftNavInner: ComponentType<PropsWithChildren> = lazy(async () => {
  const { ResizableLeftNavInner } = await import(
    /* webpackChunkName: "4-feat-resizable-left-nav" */ './internals/ResizableLeftNavInner'
  );

  return { default: ResizableLeftNavInner };
});

export default LoadableResizableLeftNavInner;
